import { render, staticRenderFns } from "./GoalCardLevelIndicators.vue?vue&type=template&id=b1f08ec8&scoped=true"
import script from "./GoalCardLevelIndicators.vue?vue&type=script&lang=js"
export * from "./GoalCardLevelIndicators.vue?vue&type=script&lang=js"
import style0 from "./GoalCardLevelIndicators.vue?vue&type=style&index=0&id=b1f08ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f08ec8",
  null
  
)

export default component.exports